import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { Button } from "../components/base/Button";
import useNotification from "../components/shared/Notifications/useNotifications";

export function useClipboardCopy() {
  const { addNotification } = useNotification();

  const handleCopy = (copyText: string) => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        addNotification({
          variant: "success",
          primaryText: "Text copied!",
        });
      })
      .catch((_) => {
        addNotification({
          variant: "error",
          primaryText: "Failed to copy text",
        });
      });
  };

  const CopyToClipboardButton = ({ copyText }: { copyText: string }) => (
    <Button size="xs" onClick={() => handleCopy(copyText)}>
      <ClipboardDocumentIcon className="w-4 h-4" />
    </Button>
  );

  return { handleCopy, CopyToClipboardButton };
}
